export interface AdStyle {
  id: string;
  coverImage: string;
  name: string;
  name_id?: string;
  category?: string;
  isCustomUpload?: boolean;
  aspectRatio?: string;
  description?: string;
  /** Used when sending to API (e.g. template URL) */
  image_url?: string;
}

export interface SelectedStyleConfig {
  style: AdStyle & { image_url: string };
  format: "1:1" | "4:5" | "9:16" | "16:9";
  colors: "auto" | "custom";
  instructions: string;
  quantity: number;
  primaryColor?: string;
  backgroundColor?: string;
}

export type Category = "all" | "viral" | "offer" | "testimonials" | "custom";

export type StyleTab = "all" | "viral" | "offer" | "testimonials" | "custom";

export const STYLE_TABS: { id: StyleTab; label: string }[] = [
  { id: "all", label: "all" },
  { id: "viral", label: "viral" },
  { id: "offer", label: "offer" },
  { id: "testimonials", label: "testimonials" },
  { id: "custom", label: "custom" },
];
